import React from 'react';
import clsx from 'clsx';

import SectionTitle from '../section-title/SectionTitle';

import scss from './PanelSection.module.scss';

function PanelSection({ title, help, icon, className, children }) {
  return (
    <section className={clsx(scss.section, className)}>
      {title ? <SectionTitle title={title} help={help} icon={icon} /> : null}
      {children}
    </section>
  );
}

export default PanelSection;
